import { Component, OnDestroy, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { CONSTANSTS } from '@core/constants';
import { I18nService } from '@core/services/i18n.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfigService } from './@core/config/config.service';
import { SharedService } from './@core/services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private titleService: Title,
    private spinner: NgxSpinnerService,
    private i18nService: I18nService,
    public readonly configSrv: ConfigService,
  ) {
    this.titleService.setTitle(this.configSrv.configuration.projectName);

    this.router.events.subscribe((event: any) => {

      // route girişince yapılacak işlemler
      if (event instanceof NavigationStart) {
        this.spinner.show(undefined, { type: null, fullScreen: true });
      }

      // route geçişi tamamlandığında yapılacak işlemler
      if (event instanceof NavigationEnd) { }

      // route geçişlerinde hata olması durumunda gerçekleşecek işlemler
      if (event instanceof NavigationError) {
        this.spinner.hide();
      }
    });
  }


  ngOnInit(): void {
    // proje ayağa kalktığında dil seçimini sağlıyoruz.
    // this.i18nService.init();
  }

  ngOnDestroy(): void {
    this.i18nService.destroy();
  }


}
